































































































































































import { Component, Watch } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { ModalFooter } from '@/components/molecules/ModalFooter'
import {
  Alert,
  AlertMessage,
  bibliographyRealApi,
  Collection,
  collectionApi,
  defaultCollection,
  defaultSimpleBibliographyReal,
  ErrorMessage,
  ShelfTypeConversionInfo,
  SimpleBibliographyReal,
  SimpleCollection,
  UpdateCollectionRequest
} from '@/api'
import {
  alertStore,
  appStore,
  dataStore,
  icTagStore,
  modalCollectionEditStore,
  modalErrorStore,
  systemCodeStore,
  systemParameterStore
} from '@/utils/store-accessor'
import { dateTimeToDateFormat } from '@/utils'
import { AlertFactory } from '@/factory'
import {
  NAV_LOADING_END,
  NAV_LOADING_START,
  PAGE_LOADING_END,
  PAGE_LOADING_START
} from '@/config/event'
import {
  CollectionEditCollectionBasicInfo,
  CollectionEditCollectionWhereAboutInfo,
  CollectionEditCollectionAcceptedAndBudgetInfo,
  InputEditBasicItem,
  InputEditWhereAboutItem,
  InputEditAcceptedAndBudgetItem,
  defaultInputEditBasicItem,
  defaultInputEditAcceptedAndBudgetItem,
  defaultInputEditWhereAboutItem,
  InputEditCollectionIcTagItem,
  defaultInputEditCollectionIcTagItem,
  CollectionEditCollectionIcTag
} from '@/components/templates/collection-edit-collection'
import {
  CollectionEditLendAndOtherLendInfo,
  CollectionEditLendAndOtherNote,
  InputEditLendItem,
  InputEditNoteItem,
  defaultInputEditLendItem,
  defaultInputEditNoteItem
} from '@/components/templates/collection-edit-lend-and-other'
import CODE_KEY from '@/config/code_key'
import {
  AlertCodeALC00002,
  AlertCodeALC00007,
  AlertCodeCLT00011,
  AlertCodeCLT00012,
  AlertCodeCLT00013,
  AlertCodeCLT00023,
  AlertCodeCLT00042,
  AlertCodeCLT00050,
  AlertCodeICT,
  AlertCodeRLC00007,
  AlertCodeRLC00008,
  AlertCodeTL700020,
  AlertCodeWAR00005,
  CollectionStatus,
  IcTagReadingParameter,
  IcTagWriteIncompatible,
  IcTagWritingParameter,
  SearchType
} from '@/types'
import { BibliographyRealInfoSimple } from '@/components/organisms/BibliographyRealInfoSimple'
import { BibliographyRealInfoMagazine } from '@/components/organisms/BibliographyRealInfoMagazine'

export interface InputEditItem {
  basic: InputEditBasicItem
  whereAbout: InputEditWhereAboutItem
  acceptedAndBudget: InputEditAcceptedAndBudgetItem
  icTag: InputEditCollectionIcTagItem
  lend: InputEditLendItem
  note: InputEditNoteItem
}

export const defaultInputEditItem = (): InputEditItem => ({
  basic: defaultInputEditBasicItem(),
  whereAbout: defaultInputEditWhereAboutItem(),
  acceptedAndBudget: defaultInputEditAcceptedAndBudgetItem(),
  icTag: defaultInputEditCollectionIcTagItem(),
  lend: defaultInputEditLendItem(),
  note: defaultInputEditNoteItem()
})

@Component({
  components: {
    CollectionEditCollectionIcTag,
    BibliographyRealInfoMagazine,
    BibliographyRealInfoSimple,
    CollectionEditLendAndOtherNote,
    CollectionEditLendAndOtherLendInfo,
    CollectionEditCollectionAcceptedAndBudgetInfo,
    CollectionEditCollectionWhereAboutInfo,
    CollectionEditCollectionBasicInfo,
    ModalFooter
  }
})
export default class ModalCollectionEdit extends ComponentVue {
  activeTab: number = 1

  editItem: InputEditItem = defaultInputEditItem()

  collection: Collection = defaultCollection()

  simpleBibliographyReal: SimpleBibliographyReal = defaultSimpleBibliographyReal()

  get processingIcTag(): boolean {
    return icTagStore.processing
  }

  get isMagazine(): boolean {
    return this.simpleBibliographyReal.searchType.code === SearchType.Magazine
  }

  get currentStatus(): string {
    return this.collection.status.code
  }

  get existsCollectionLendUserId(): boolean {
    return this.collection.collectionLendUserId !== ''
  }

  get fontSize(): number {
    return appStore._fontSizeNormal
  }

  get fontSizeType(): string {
    return appStore._fontSizeType
  }

  get isOpen(): boolean {
    return modalCollectionEditStore.isOpen
  }

  get isStatusOtherClass(): boolean {
    return this.editItem.basic.status.input === CollectionStatus.OtherForwarding
  }

  get isCollectionStatusBookBinding(): boolean {
    return this.collection.status.code === CollectionStatus.BookBinding
  }

  get isCollectionStatusComposed(): boolean {
    return this.collection.status.code === CollectionStatus.Composed
  }

  get isCollectionStatusDelete(): boolean {
    return this.editItem.basic.status.input === CollectionStatus.Delete
  }

  get tabStyles(): object {
    if (this.fontSizeType === 'normal') {
      return {}
    }

    return {
      'font-size': this.fontSize + 'px'
    }
  }

  get enabledIcTag(): boolean {
    return dataStore.enabledIcTag
  }

  get enabledIcTagUid(): boolean {
    return dataStore.enabledIcTagUid
  }

  get isChangeParentComposedCollectionId(): boolean {
    return (
      this.editItem.basic.parentComposedCollectionNo.input !== '' &&
      this.editItem.basic.parentComposedCollectionNo.input !==
        this.collection.parentComposedCollectionNo &&
      (this.editItem.basic.status.input ===
        CollectionStatus.PreparingToAccept ||
        this.editItem.basic.status.input === CollectionStatus.Shelf ||
        this.editItem.basic.status.input === CollectionStatus.Repairing ||
        this.editItem.basic.status.input === CollectionStatus.Composed)
    )
  }

  // スプレッド構文を用いてベースのリクエストとして使用する
  get defaultUpdateRequest(): UpdateCollectionRequest {
    return {
      id: this.collection.id,
      collectionNo: this.collection.collectionNo,
      parentComposedCollectionId: this.collection.parentComposedCollectionId,
      parentComposedCollectionNo: this.collection.parentComposedCollectionNo,
      status: this.collection.status.code,
      removeReason: this.collection.removeReason.code,
      removeDate: dateTimeToDateFormat(this.collection.removeTime),
      removeExpectedDate: this.collection.removeExpectedDate,
      publishDate: this.collection.publishDate,
      collectionType: this.collection.collectionType.code,
      handlingType: this.collection.handlingType.code,
      storeType: this.collection.storeType.code,
      appendixCode: this.collection.appendixCode.code,
      opacShow: this.collection.opacShow,
      holdingBranchCode: this.collection.holdingBranchCode.code,
      departmentCode: this.collection.departmentCode.code,
      forwardingBranchCode: this.collection.forwardingBranchCode.code,
      shelfType: this.collection.shelfType.code,
      shelfTypeOld: this.collection.shelfTypeOld.code,
      mark: this.collection.mark,
      ndc: this.collection.ndc,
      book: this.collection.book,
      sub: this.collection.sub,
      acceptDate: this.collection.acceptDate,
      acceptType: this.collection.acceptType.code,
      acceptPrice: this.collection.acceptPrice,
      listPrice: this.collection.listPrice,
      applicantUserId: this.collection.applicantUserId,
      traderCode: this.collection.traderCode.code,
      donorCode: this.collection.donorCode.code,
      budgetYear: this.collection.budgetYear,
      budgetBranchCode: this.collection.budgetBranchCode.code,
      budgetDepartmentCode: this.collection.budgetDepartmentCode.code,
      budgetExpenseCode: this.collection.budgetExpenseCode.code,
      equipType: this.collection.equipType.code,
      workMemo: this.collection.workMemo,
      displayMemo: this.collection.displayMemo,
      localMemo: this.collection.localMemo,
      interlibraryLoanCode: this.collection.interlibraryLoanCode.code,
      borrowingDate: this.collection.borrowingDate,
      borrowingDueDate: this.collection.borrowingDueDate,
      revision: this.collection.revision,
      _isUpdateChildCollection: false,
      icTagUid: this.collection.icTagUid,
      setNumber: this.collection.setNumber
    }
  }

  @Watch('isOpen')
  initialize(newVal: boolean): void {
    if (newVal) {
      systemCodeStore.fetchAllAndMergeByCodeKeys([CODE_KEY.COLLECTION_MEMO.KEY])
      systemParameterStore.fetchAllAndMergeByCodeKeys([
        CODE_KEY.NUMBER_MANAGEMENT.KEY // 利用者番号入力欄で使用している
      ])
      this.getSimpleBibliographyReal()
      this.getCollection().catch(modalCollectionEditStore.close)
      return
    }

    this.activeTab = 1
    this.editItem = defaultInputEditItem()
    this.collection = defaultCollection()
  }

  icReading(): Promise<IcTagReadingParameter> {
    return new Promise((resolve, reject) => {
      this.$webSocket.sendICTagReading(
        '',
        (isConnect: boolean, parameter?: IcTagReadingParameter) => {
          if (!isConnect || !parameter) {
            reject(new Error())
            return
          }

          if (!parameter.result) {
            alertStore.setItem(AlertFactory.create(AlertCodeCLT00023))
            this.$modalAlert.open({
              onOkClick: () => reject(new Error())
            })
            return
          }

          if (parameter.data.length === 0) {
            alertStore.setItem(AlertFactory.create(AlertCodeRLC00007))
            this.$modalAlert.open({
              onOkClick: () => reject(new Error())
            })
            return
          }

          // 複数タグに限り、リーダで読み込んだ全てのタグをチェックする
          if (parameter.data.length > 1) {
            alertStore.setItem(AlertFactory.create(AlertCodeRLC00008))
            this.$modalAlert.open({
              onOkClick: () => reject(new Error())
            })
            return
          }

          resolve(parameter)
        }
      )
    })
  }

  async icWriting(): Promise<void> {
    const sendIcTagReading = async (): Promise<IcTagReadingParameter> => {
      const alerts: Alert[] = []
      const parameter: IcTagReadingParameter = await this.icReading()

      if (parameter.data[0].oldTag === '1') {
        alertStore.setItem({
          code: AlertCodeICT,
          level: 'ERROR',
          message: '書込みに対応していないＩＣタグが置かれています。',
          attribute: '',
          index: 0,
          subAttribute: ''
        })
        return new Promise((resolve, reject) => {
          this.$modalAlert.open({
            onOkClick: () => reject(new Error())
          })
        })
      }

      if (parameter.data[0].no !== '0'.repeat(parameter.data[0].no.length)) {
        const alert: Alert = AlertFactory.create(
          AlertCodeCLT00011,
          parameter.data[0].industryCode,
          parameter.data[0].branchType,
          parameter.data[0].agencyCode,
          parameter.data[0].no
        )
        alert.level = 'WARN' // DB上でERRORとして設定されているのでこちらで対応を取る

        alerts.push(alert)
      }

      if (this.enabledIcTagUid && this.editItem.icTag.icTagUid !== '') {
        alerts.push(
          AlertFactory.create(AlertCodeALC00007, 'ICタグUID', '上書き')
        )
      }

      if (alerts.length > 0) {
        alertStore.setItems(alerts)
        return new Promise((resolve, reject) => {
          this.$modalAlert.open({
            onOkClick: () => resolve(parameter),
            onCancelClick: () => reject(new Error())
          })
        })
      }

      return Promise.resolve(parameter)
    }
    // ここ以外で使うなら関数として定義する
    const sendICTagWriting = () =>
      new Promise(resolve => {
        // ここに入った時点で終了処理を確定で行いたいので常にresolve()とする
        this.$webSocket.sendICTagWriting(
          {
            industryCode: dataStore.industryCode,
            branchType: dataStore.branchType,
            agencyCode: dataStore.agencyCode,
            noFlag: '0',
            no: this.editItem.basic.collectionNo.input
          },
          (isConnect: boolean, parameter?: IcTagWritingParameter) => {
            if (!isConnect || !parameter) {
              resolve()
              return
            }

            if (parameter.code === IcTagWriteIncompatible) {
              alertStore.setItem({
                code: AlertCodeICT,
                level: 'ERROR',
                message: '書込みに対応していないＩＣタグが置かれています。',
                attribute: '',
                index: 0,
                subAttribute: ''
              })
              this.$modalAlert.open({
                onOkClick: resolve
              })
              return
            }

            if (!parameter.result) {
              alertStore.setItem(
                AlertFactory.create(AlertCodeCLT00012, 'ICタグ')
              )
              this.$modalAlert.open({
                onOkClick: resolve
              })
              return
            }

            alertStore.setItem(AlertFactory.create(AlertCodeCLT00013))
            this.$modalAlert.open({
              onOkClick: resolve
            })
          }
        )
      })

    icTagStore.startProcess()

    try {
      const parameter: IcTagReadingParameter = await sendIcTagReading()
      await this.onBeforeFirstCallUpdateApi({
        icTagUid: parameter.data[0].tagNo
      })
      await sendICTagWriting()
      modalCollectionEditStore.close()
    } catch {
    } finally {
      icTagStore.endProcess()
    }
  }

  async registerIcTagUid(): Promise<void> {
    icTagStore.startProcess()

    try {
      const response: IcTagReadingParameter = await this.icReading()
      await this.updateCollectionIcTagUid(response.data[0].tagNo)
    } catch {
    } finally {
      icTagStore.endProcess()
    }
  }

  deleteIcTagUid(): void {
    const alert: Alert = AlertFactory.create(
      AlertCodeALC00007,
      'ICタグUID',
      '削除'
    )
    alertStore.setItem(alert)
    this.$modalAlert.open({
      onOkClick: this.updateCollectionIcTagUid
    })
  }

  onClickCancel(): void {
    const alert: Alert = AlertFactory.create(AlertCodeALC00002)
    alertStore.setItem(alert)
    this.$modalAlert.open({
      onOkClick: modalCollectionEditStore.close
    })
  }

  onClickReleaseComposed(): void {
    alertStore.setItem(
      AlertFactory.create(
        AlertCodeWAR00005,
        this.editItem.basic.parentComposedCollectionNo.input +
          'の構成資料から解除'
      )
    )
    this.$modalAlert.open({
      onOkClick: this.releaseParentComposedCollection
    })
  }

  onClickRegistration(): void {
    const update = () =>
      this.onBeforeFirstCallUpdateApi()
        .then(modalCollectionEditStore.close)
        .catch()

    if (this.isCollectionStatusDelete) {
      if (this.collection.childComposedCollectionIds.length > 0) {
        alertStore.setItem(
          AlertFactory.create(AlertCodeALC00007, '資料及び構成資料', '削除')
        )
      } else {
        alertStore.setItem(
          AlertFactory.create(AlertCodeALC00007, '資料', '削除')
        )
      }
      this.$modalAlert.open({
        modalType: 'WARN',
        onOkClick: update
      })
    } else if (!this.isChangeParentComposedCollectionId) {
      alertStore.setItem(AlertFactory.create(AlertCodeCLT00042, '資料'))
      this.$modalAlert.open({
        modalType: 'WARN',
        onOkClick: update
      })
    } else {
      update()
    }
  }

  print() {
    const element = document.querySelector('#modal-collection-edit')

    if (element) {
      this.$webSocket.sendDialogScreenshotMessage(element)
    } else {
      this.$webSocket.sendScreenshotMessage()
    }
  }

  setEditItem(): void {
    this.editItem = {
      basic: {
        collectionId: {
          input: this.collection.id,
          errorMessage: ''
        },
        collectionNo: {
          input: this.collection.collectionNo,
          errorMessage: ''
        },
        collectionType: {
          input: this.collection.collectionType.code,
          errorMessage: ''
        },
        storeType: {
          input: this.collection.storeType.code,
          errorMessage: ''
        },
        opacShow: {
          input: this.collection.opacShow,
          errorMessage: ''
        },
        status: {
          input: this.collection.status.code,
          errorMessage: ''
        },
        handlingType: {
          input: this.collection.handlingType.code,
          errorMessage: ''
        },
        appendixCode: {
          input: this.collection.appendixCode.code,
          errorMessage: ''
        },
        removeReason: {
          input: this.collection.removeReason.code,
          errorMessage: ''
        },
        // 日付
        removeDate: {
          input: dateTimeToDateFormat(this.collection.removeTime),
          errorMessage: ''
        },
        // 日付
        removeExpectedDate: {
          input: this.collection.removeExpectedDate,
          errorMessage: ''
        },
        publishDate: {
          input: this.collection.publishDate,
          errorMessage: ''
        },
        parentCollectionNo: this.collection.parentCollectionNo,
        parentComposedCollectionNo: {
          input: this.collection.parentComposedCollectionNo,
          errorMessage: ''
        },
        setNumber: {
          input: String(this.collection.setNumber),
          errorMessage: ''
        }
      },
      whereAbout: {
        holdingBranchCode: {
          input: this.collection.holdingBranchCode.code,
          errorMessage: ''
        },
        forwardingBranchCode: {
          input: this.collection.forwardingBranchCode.code,
          errorMessage: ''
        },
        departmentCode: {
          input: this.collection.departmentCode.code,
          errorMessage: ''
        },
        shelfType: {
          input: this.collection.shelfType.code,
          errorMessage: ''
        },
        shelfTypeOld: {
          input: this.collection.shelfTypeOld.code,
          errorMessage: ''
        },
        mark: {
          input: this.collection.mark,
          errorMessage: ''
        },
        ndc: {
          input: this.collection.ndc,
          errorMessage: ''
        },
        book: {
          input: this.collection.book,
          errorMessage: ''
        },
        sub: {
          input: this.collection.sub,
          errorMessage: ''
        }
      },
      icTag: {
        icTagUid: this.collection.icTagUid
      },
      acceptedAndBudget: {
        acceptDate: {
          input: this.collection.acceptDate,
          errorMessage: ''
        },
        acceptType: {
          input: this.collection.acceptType.code,
          errorMessage: ''
        },
        acceptPrice: {
          input: String(this.collection.acceptPrice),
          errorMessage: ''
        },
        listPrice: {
          input: String(this.collection.listPrice),
          errorMessage: ''
        },
        applicantUserId: {
          input: this.collection.applicantUserId,
          errorMessage: ''
        },
        traderCode: {
          input: this.collection.traderCode.code,
          errorMessage: ''
        },
        donorCode: {
          input: this.collection.donorCode.code,
          errorMessage: ''
        },
        budgetYear: {
          input: String(this.collection.budgetYear),
          errorMessage: ''
        },
        budgetBranchCode: {
          input: this.collection.budgetBranchCode.code,
          errorMessage: ''
        },
        budgetDepartmentCode: {
          input: this.collection.budgetDepartmentCode.code,
          errorMessage: ''
        },
        budgetExpenseCode: {
          input: this.collection.budgetExpenseCode.code,
          errorMessage: ''
        },
        equipType: {
          input: this.collection.equipType.code,
          errorMessage: ''
        }
      },
      lend: {
        interlibraryLoanCode: {
          input: this.collection.interlibraryLoanCode.code,
          errorMessage: ''
        },
        borrowingDate: {
          input: this.collection.borrowingDate,
          errorMessage: ''
        },
        borrowingDueDate: {
          input: this.collection.borrowingDueDate,
          errorMessage: ''
        }
      },
      note: {
        workMemo: {
          input: this.collection.workMemo,
          code: '',
          time: this.collection.workMemoTime,
          place: this.collection.workMemoPlaceCode.shortName,
          errorMessage: ''
        },
        displayMemo: {
          input: this.collection.displayMemo,
          code: '',
          time: this.collection.displayMemoTime,
          place: this.collection.displayMemoPlaceCode.shortName,
          errorMessage: ''
        },
        localMemo: {
          input: this.collection.localMemo,
          code: '',
          time: this.collection.localMemoTime,
          place: this.collection.localMemoPlaceCode.shortName,
          errorMessage: ''
        }
      }
    }
  }

  setErrorMessage(alerts: Alert[]): void {
    const array: any[] = Object.entries(this.editItem)
    alerts.some(alert => {
      if (alert.attribute === '') return false

      const convertedPropertyName: string = alert.attribute.replace(
        /_./g,
        str => str.charAt(1).toUpperCase()
      )

      array.some(value => {
        if (value[1][convertedPropertyName]) {
          value[1][convertedPropertyName].errorMessage = alert.message
          return true
        }

        return false
      })
    })
    this.editItem = Object.fromEntries(array) as InputEditItem
  }

  async getSimpleBibliographyReal(): Promise<void> {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      this.simpleBibliographyReal = await bibliographyRealApi.getSimpleBibliographyReal(
        modalCollectionEditStore.bibliographyRealId
      )
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  async getCollection(): Promise<void> {
    await this.getCollectionInterface(false)
  }

  async reconfigureCollection(): Promise<void> {
    await this.getCollectionInterface(true)
  }

  async getCollectionInterface(isReconfigure: boolean): Promise<void> {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      this.collection = await collectionApi.getCollection(
        modalCollectionEditStore.collectionId
      )

      if (isReconfigure) {
        this.editItem.icTag.icTagUid = this.collection.icTagUid
        // icTagUidと違い、最新のデータとする意義が薄い箇所だが、テキスト表示の箇所なので一応設定
        this.editItem.basic.parentCollectionNo = this.collection.parentCollectionNo
      } else {
        this.setEditItem()
      }
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        return new Promise((resolve, reject) => {
          this.$modalAlert.open({
            onOkClick: () => reject(new Error())
          })
        })
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        return new Promise((resolve, reject) => {
          this.$modalError.open({
            onOkClick: () => reject(new Error())
          })
        })
      } else {
        console.error(error)
      }

      throw error
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  async onBeforeFirstCallUpdateApi(
    updateControlValues: {
      icTagUid?: string
    } = {}
  ): Promise<void> {
    const { icTagUid = '' } = updateControlValues

    const update = async () => {
      await this.updateCollection({
        icTagUid
      })
    }

    if (this.isChangeParentComposedCollectionId) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          alertStore.setItem(
            AlertFactory.create(
              AlertCodeWAR00005,
              this.editItem.basic.parentComposedCollectionNo.input +
                'の構成資料に変更'
            )
          )
          this.$modalAlert.open({
            onOkClick: async () => {
              try {
                await update()
                resolve()
              } catch (error) {
                reject(error)
              }
            },
            onCancelClick: reject
          })
        }, 100)
      })
    } else {
      await update()
    }
  }

  async releaseParentComposedCollection(): Promise<void> {
    try {
      await this.updateCollectionInterface({
        ...this.defaultUpdateRequest,
        parentComposedCollectionId: 0,
        parentComposedCollectionNo: '',
        status: CollectionStatus.Shelf
      })
      modalCollectionEditStore.close()
    } catch (error) {
      if (error instanceof AlertMessage) {
        this.setErrorMessage(error.alerts)
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    }
  }

  async updateCollection(
    updateControlValues: {
      _isUpdateChildCollection?: boolean
      icTagUid?: string
      parentComposedCollectionId?: number
    } = {}
  ): Promise<void> {
    const {
      _isUpdateChildCollection = false,
      icTagUid = '',
      parentComposedCollectionId = 0
    } = updateControlValues

    const baseRequest: UpdateCollectionRequest = {
      ...this.defaultUpdateRequest,
      id: this.editItem.basic.collectionId.input,
      collectionNo: this.editItem.basic.collectionNo.input,
      status: this.editItem.basic.status.input,
      removeReason: this.editItem.basic.removeReason.input,
      removeDate: this.editItem.basic.removeDate.input,
      removeExpectedDate: this.editItem.basic.removeExpectedDate.input,
      publishDate: this.editItem.basic.publishDate.input,
      collectionType: this.editItem.basic.collectionType.input,
      handlingType: this.editItem.basic.handlingType.input,
      storeType: this.editItem.basic.storeType.input,
      appendixCode: this.editItem.basic.appendixCode.input,
      opacShow: this.editItem.basic.opacShow.input,
      holdingBranchCode: this.editItem.whereAbout.holdingBranchCode.input,
      departmentCode: this.editItem.whereAbout.departmentCode.input,
      forwardingBranchCode: this.editItem.whereAbout.forwardingBranchCode.input,
      shelfType: this.editItem.whereAbout.shelfType.input,
      shelfTypeOld: this.editItem.whereAbout.shelfTypeOld.input,
      mark: this.editItem.whereAbout.mark.input,
      ndc: this.editItem.whereAbout.ndc.input,
      book: this.editItem.whereAbout.book.input,
      sub: this.editItem.whereAbout.sub.input,
      acceptDate: this.editItem.acceptedAndBudget.acceptDate.input,
      acceptType: this.editItem.acceptedAndBudget.acceptType.input,
      acceptPrice: Number(this.editItem.acceptedAndBudget.acceptPrice.input),
      listPrice: Number(this.editItem.acceptedAndBudget.listPrice.input),
      applicantUserId: this.editItem.acceptedAndBudget.applicantUserId.input,
      traderCode: this.editItem.acceptedAndBudget.traderCode.input,
      donorCode: this.editItem.acceptedAndBudget.donorCode.input,
      budgetYear: Number(this.editItem.acceptedAndBudget.budgetYear.input),
      budgetBranchCode: this.editItem.acceptedAndBudget.budgetBranchCode.input,
      budgetDepartmentCode: this.editItem.acceptedAndBudget.budgetDepartmentCode
        .input,
      budgetExpenseCode: this.editItem.acceptedAndBudget.budgetExpenseCode
        .input,
      equipType: this.editItem.acceptedAndBudget.equipType.input,
      workMemo: this.editItem.note.workMemo.input,
      displayMemo: this.editItem.note.displayMemo.input,
      localMemo: this.editItem.note.localMemo.input,
      interlibraryLoanCode: this.editItem.lend.interlibraryLoanCode.input,
      borrowingDate: this.editItem.lend.borrowingDate.input,
      borrowingDueDate: this.editItem.lend.borrowingDueDate.input,
      _isUpdateChildCollection,
      icTagUid: this.collection.icTagUid,
      setNumber: Number(this.editItem.basic.setNumber.input)
    }

    if (this.isChangeParentComposedCollectionId) {
      if (parentComposedCollectionId) {
        baseRequest.parentComposedCollectionId = parentComposedCollectionId
      } else {
        baseRequest.parentComposedCollectionId = 0
        baseRequest.parentComposedCollectionNo = this.editItem.basic.parentComposedCollectionNo.input
      }
    }

    if (this.enabledIcTagUid) {
      baseRequest.icTagUid = icTagUid
    }

    try {
      await this.updateCollectionInterface(baseRequest)
    } catch (error) {
      if (error instanceof AlertMessage) {
        if (
          error.alerts.length === 1 &&
          error.alerts[0].code === AlertCodeTL700020
        ) {
          await this.getSimpleParentComposedCollection({
            _isUpdateChildCollection,
            icTagUid
          })
          return
        }

        this.setErrorMessage(error.alerts)
        alertStore.setItems(error.alerts)
        return new Promise((resolve, reject) => {
          this.$modalAlert.open({
            onOkClick: async () => {
              if (error.alerts[0].code === AlertCodeCLT00050) {
                try {
                  await this.updateCollection({
                    _isUpdateChildCollection: true,
                    icTagUid,
                    parentComposedCollectionId
                  })
                  resolve()
                } catch (error) {
                  reject(error)
                }
              } else {
                reject(error)
              }
            },
            onCancelClick: () => reject(new Error())
          })
        })
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        return new Promise((resolve, reject) => {
          this.$modalError.open({
            onOkClick: () => reject(new Error())
          })
        })
      } else {
        console.error(error)
      }

      throw error
    }
  }

  async updateCollectionInterface(
    request: UpdateCollectionRequest
  ): Promise<void> {
    await collectionApi.updateCollection(request)
    modalCollectionEditStore.onUpdate()
  }

  async convertShelfType(): Promise<void> {
    if (
      this.editItem.basic.collectionType.input === '' &&
      this.editItem.whereAbout.mark.input === '' &&
      this.editItem.whereAbout.ndc.input === '' &&
      this.editItem.whereAbout.book.input === '' &&
      this.editItem.whereAbout.sub.input === ''
    ) {
      return
    }

    this.$eventBus.emit(NAV_LOADING_START)

    try {
      const response: ShelfTypeConversionInfo = await collectionApi.getShelfTypeConversionInfo(
        {
          collectionType: this.editItem.basic.collectionType.input,
          mark: this.editItem.whereAbout.mark.input,
          ndc: this.editItem.whereAbout.ndc.input,
          book: this.editItem.whereAbout.book.input,
          sub: this.editItem.whereAbout.sub.input
        }
      )

      this.editItem.whereAbout.shelfType.input = response.shelfType
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(NAV_LOADING_END)
    }
  }

  async updateCollectionIcTagUid(icTagUid: string = ''): Promise<void> {
    try {
      await collectionApi.updateCollectionIcTagUid({
        id: this.editItem.basic.collectionId.input,
        icTagUid,
        revision: this.collection.revision
      })

      modalCollectionEditStore.onUpdate()
      await this.reconfigureCollection()
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        return new Promise((resolve, reject) => {
          this.$modalAlert.open({
            onOkClick: () => reject(new Error())
          })
        })
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        return new Promise((resolve, reject) => {
          this.$modalError.open({
            onOkClick: () => reject(new Error())
          })
        })
      } else {
        console.error(error)
      }

      throw error
    }
  }

  async getSimpleParentComposedCollection(updateControlValues: {
    _isUpdateChildCollection: boolean
    icTagUid: string
  }): Promise<void> {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      const collections: SimpleCollection[] = await collectionApi.getSimpleCollections(
        {
          collectionNo: this.editItem.basic.parentComposedCollectionNo.input
        }
      )

      return new Promise((resolve, reject) => {
        this.$modalCollectionSelect.open({
          collectionNo: this.editItem.basic.parentComposedCollectionNo.input,
          simpleCollections: collections,
          onClickOk: async (id: number) => {
            try {
              await this.updateCollection({
                ...updateControlValues,
                parentComposedCollectionId: id
              })
              resolve()
            } catch (error) {
              reject(error)
            }
          }
        })
      })
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        return new Promise((resolve, reject) => {
          this.$modalAlert.open({
            onOkClick: () => reject(new Error())
          })
        })
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        return new Promise((resolve, reject) => {
          this.$modalError.open({
            onOkClick: () => reject(new Error())
          })
        })
      } else {
        console.error(error)
      }

      throw error
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }
}
